export default __webpack_public_path__ + "static/media/091d499819787fd1fdd41eca63240c9a.svg";